/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} External_Apis_DescriptionInputs */



/**
* | output |
* | --- |
* | "Approve the external APIs the assistant may call, then create a space for each credential. Whoever may use a space spends its credential, and only in the pro..." |
*
* @param {External_Apis_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const external_apis_description = /** @type {((inputs?: External_Apis_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<External_Apis_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Geben Sie die externen APIs frei, die der Assistent aufrufen darf, und legen Sie für jede Zugangsberechtigung einen Space an. Wer einen Space nutzen darf, verwendet dessen Zugangsdaten – und nur in den Projekten, in die er ihn verknüpft. Alles andere wird abgewiesen, bevor eine Anfrage das System verlässt.")
	return /** @type {LocalizedString} */ ("Approve the external APIs the assistant may call, then create a space for each credential. Whoever may use a space spends its credential, and only in the projects they link it into. Everything else is refused before any request leaves.")
});